import SlowUploadAlert from './SlowUploadAlert';
export default SlowUploadAlert;
